import { Box, makeStyles } from '@material-ui/core';
import { DataGrid, jaJP } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import OnOffByScroll from '../../../Animation/onOffByScroll';
import { instructorIndexForAdmin } from '../../../Apis/apiOfManaged';
import { AuthContext } from '../../../auth';
import { localStorageArrayHandler } from '../../../CommonFunction/managePermission';
import Footer from '../../../Footer/footer';
import various from '../../../General/various';
import { Spinner } from '../../../Spinner';
import BreadCrumbs from '../../../General/breadCrumbs';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    margin: '0px 0px 80px 0px',
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      textAlign: 'start',
      '& > span': {
        display: 'inline-block',
        marginRight: '24px',
        fontSize: '0.9rem',
      },
      '& #title': {
        fontWeight: 'bold',
        fontSize: theme.typography.fontSize,
      },
    },
  },
  container: {
    marginTop: '64px',
  },
  dataGrid: {
    height: (props) =>
      props.heightSize ? props.heightSize : props.pageSize * props.rowHeight,
    width: '100%',
  },
}));

const InstructorIndex = () => {
  const { isAuth } = useContext(AuthContext);
  const permissions = localStorageArrayHandler('parse', various.permissionKey);

  const [date, setDate] = useState();
  const [instructors, setInstructors] = useState();
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [heightSize, setHeightSize] = useState();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const ROWHEIGHT = 80;
  const PAGESIZE = 30;
  const classes = useStyles({
    pageSize: PAGESIZE,
    rowHeight: ROWHEIGHT,
    heightSize: heightSize,
  });

  const CRUMBS = [
    { name: '管理画面Top', path: '/manage/index' },
    { name: '指導者一覧', path: '/manage/instructor_index' },
  ];

  // Init
  useEffect(() => {
    const weekday = ['日', '月', '火', '水', '木', '金', '土'];
    const d = new Date();
    setDate(
      d.getFullYear() +
        '年' +
        (d.getMonth() + 1) +
        '月' +
        d.getDate() +
        '日' +
        '（' +
        weekday[d.getDay()] +
        '）'
    );
  }, []);

  useEffect(() => {
    instructorIndexForAdmin(setInstructors, 'working');
  }, []);

  // Handler
  const handleAuth = () => {
    navigate(various.general.login, { state: { previous: location.pathname } });
  };

  const handleClick = (flag, row) => {
    if (flag === 'update') {
      navigate(various.general.instructorUpdate, {
        state: { previous: location.pathname, uuid: row.uuid },
      });
    } else if (flag === 'detail') {
      navigate(various.general.instructorDetail, {
        state: { previous: location.pathname, uuid: row.uuid },
      });
    } else if (flag === 'paymentMethod') {
      navigate(various.general.instructorPaymentMethodCreate, {
        state: { previous: location.pathname, uuid: row.uuid },
      });
    } else if (flag === 'paymentMethodUpdate') {
      navigate(various.general.instructorPaymentMethodUpdate, {
        state: { previous: location.pathname, uuid: row.uuid },
      });
    }
  };

  // Contents
  useEffect(() => {
    if (instructors) {
      setColumns([
        {
          field: 'id',
          headerName: 'ID',
          width: 10,
        },
        {
          field: 'uuid',
        },
        {
          field: 'name',
          headerName: '指導者氏名',
          cellClassName: 'instructor-name',
          width: 200,
        },
        {
          field: 'image',
          headerName: 'イメージ',
          cellClassName: 'image-cell',
          width: 150,
          renderCell: (params) => (
            <img src={params.row.image} alt={`image_${params.id}`} />
          ),
        },
        {
          field: 'is_working',
          headerName: '運用区分',
          width: 100,
        },
        {
          field: 'career',
          headerName: '経歴',
          cellClassName: 'career',
          width: 200,
        },
        {
          field: 'biography',
          headerName: '略歴',
          cellClassName: 'biography',
          width: 200,
        },
        {
          field: 'account',
          headerName: 'アカウント',
          width: 150,
        },
        {
          field: 'detailBtn',
          headerName: '詳細',
          sortable: false,
          width: 100,
          disableClickEventBubbling: true,
          renderCell: (params) => (
            <div>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick('detail', params.row)}
              >
                詳細
              </button>
            </div>
          ),
        },
        {
          field: 'updateBtn',
          headerName: '更新',
          sortable: false,
          width: 100,
          disableClickEventBubbling: true,
          renderCell: (params) => (
            <div>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick('update', params.row)}
              >
                更新
              </button>
            </div>
          ),
        },
        {
          field: 'paymentMethodBtn',
          headerName: '決済方法',
          sortable: false,
          width: 100,
          disableClickEventBubbling: true,
          renderCell: (params) => (
            <div>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick('paymentMethod', params.row)}
              >
                登録
              </button>
            </div>
          ),
        },
        {
          field: 'paymentMethodUpdateBtn',
          headerName: '決済方法更新',
          sortable: false,
          width: 100,
          disableClickEventBubbling: true,
          renderCell: (params) => (
            <div>
              <button
                style={{ cursor: 'pointer' }}
                onClick={() => handleClick('paymentMethodUpdate', params.row)}
              >
                更新
              </button>
            </div>
          ),
        },
      ]);

      const date = new Date().getTime();
      setRows(
        instructors.map((instructor, index) => {
          const row = {};
          row['id'] = index + 1;
          row['uuid'] = instructor.uuid;
          row['name'] = instructor.name;
          row['image'] = `${instructor.image}?v=${date}`;
          row['is_working'] = instructor.is_working ? '指導中' : '休止中';
          row['career'] = instructor.career;
          row['biography'] = instructor.biography;
          row['account'] = instructor.user.email;
          return row;
        })
      );
      setHeightSize(instructors.length * ROWHEIGHT * 1.4 + 122);
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [instructors]);

  return (
    <>
      <>
        <div style={{ margin: '80px' }}>
          <OnOffByScroll place="General" />
        </div>
        {!isAuth ? (
          <div>
            <span
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={handleAuth}
            >
              ログイン
            </span>
            してください。
          </div>
        ) : permissions.includes('admin') ? (
          <>
            <div className={classes.pageTitle}>
              <div>
                <span id="title">指導者一覧</span>
                <span>{date}</span>
              </div>
            </div>
            <hr />
            <BreadCrumbs crumbs={CRUMBS} />
            {loading ? (
              <Spinner />
            ) : (
              <div className={classes.container}>
                <Box
                  className={classes.dataGrid}
                  sx={{
                    '& .image-cell': {
                      '& > img': {
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                      },
                    },
                    '& .descs-cell': {
                      '& > div': {
                        overFrow: 'scroll !important',
                      },
                    },
                    '& .instructor-name': {
                      fontStyle: 'italic',
                      fontFamily:
                        '"Times New Roman", "YuMincho", "Hiragino Mincho ProN", "Yu Mincho", "MS PMincho", serif',
                      fontWeight: 'bold',
                    },
                  }}
                >
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={PAGESIZE}
                    rowsPerPageOptions={[PAGESIZE]}
                    // checkboxSelection
                    density="comfortable"
                    columnVisibilityModel={{ uuid: false }}
                    pagination={true}
                    autoPageSize={true}
                    rowHeight={ROWHEIGHT}
                    disableSelectionOnClick
                    experimentalFeatures={{ newEditingApi: true }}
                    localeText={
                      jaJP.components.MuiDataGrid.defaultProps.localeText
                    }
                  />
                </Box>
              </div>
            )}
          </>
        ) : permissions === 'null' ? (
          setTimeout(() => {
            window.location.reload(true);
          }, 500)
        ) : (
          <>
            <div className={classes.pageTitle}>
              <div>
                <span id="title">指導者一覧</span>
                <span>{date}</span>
              </div>
            </div>
            <hr />
            <BreadCrumbs crumbs={CRUMBS} />
            <div className={classes.container}>権限がありません</div>
          </>
        )}
        <Footer />
      </>
    </>
  );
};
export default InstructorIndex;
